const rem = (...args: number[]): string =>
  args.map((current) => `${current / 16}rem`).join(" ");

export { rem };
